export const handleAdminError = (error) => {
  if (!error.body) return error.message || 'An error occurred. Please try again.'

  const errorObject = error.body

  switch (errorObject.code) {
    case 'COM-9': {
      if (
        JSON.stringify(errorObject)
          .toLowerCase()
          .includes('password')
      ) {
        return 'Password should have length more then 8 characters, have small and capital and also special character, have number.'
      }
      return errorObject.message
    }
    default:
      return errorObject.message
  }
}
